import Store from 'store/store';
import * as cookieUtils from 'utils/cookies';

Store.on('TOGGLE_COOKIES_PREFERENCE_CENTER', show => {
	let cookies = Store.get().cookies;
	let showPreferenceCenter = typeof show === 'boolean' ? show : !cookies.showPreferenceCenter;
	cookies.set({ showPreferenceCenter });
});

Store.on('SET_COOKIE_LEVELS', (allowed) => {
	let cookies = Store.get().cookies;
	cookies.set({ allowed });
	cookieUtils.persist(allowed);
	cookieUtils.trigger(allowed);
});

Store.on('ACCEPT_ALL_COOKIES', () => {
	const all = cookieUtils.levels.reduce((all, level) => {
		all[level.type] = true;
		return all;
	}, {});
	Store.emit('SET_COOKIE_LEVELS', all);
});
